<template>

    <b-card>

        <b-row>

            <b-col lg="12">

                <b-row>

                    <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                        <date-picker
                            v-model="start_date"
                            placeholder="Start Date"
                            class="f-1">
                        </date-picker> &nbsp;to&nbsp;
                        <date-picker
                            v-model="end_date"
                            placeholder="End Date"
                            class="f-1">
                        </date-picker>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">

                        <user-role-search-dropdown type="provider" v-model=" caregiver_id "></user-role-search-dropdown>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">

                        <carrier-parents-dropdown v-model=" parent_carrier " :role=" role "></carrier-parents-dropdown>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">

                        <carrier-dropdown v-model=" carrier " :role=" role "></carrier-dropdown>
                    </b-col>
                </b-row>

                <b-row class="my-2">

                    <b-col class="d-flex align-items-center justify-content-end">

                        <b-btn class="my-1 mr-1" variant="success" :href="`/business/reports/frequent-offenders${this.queryString}&export=1`" :disabled="loading"><i class="fa fa-file-excel-o"></i> Export to Excel</b-btn>
                        <b-button class="my-1" @click=" reload() " variant="info" :disabled=" loading ">Generate</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <loading-card v-if="loading" />

        <b-table v-else :items="items" :fields="fields" show-empty class="table table-striped table-responsive">

            <template v-slot:cell(clients)="row">
                <span v-for="(client, id) in row.item.clients" :key="id">
                    <a :href="`/business/clients/${id}`">{{ client.name }}</a><br />
                </span>
            </template>
            <template v-slot:cell(caregiver)="row">
                <a :href="`/business/caregivers/${row.item.caregiver.id}`">{{ row.item.caregiver.name }}</a>
            </template>
            <template v-slot:cell(send_training_email)="row">
                <b-btn @click="sendTrainingEmail(row.item.caregiver)">Send</b-btn>
            </template>
        </b-table>
    </b-card>
</template>

<script>

    import HasCarrierDropdowns from '../../../mixins/HasCarrierDropdowns';

    export default {

        mixins: [ HasCarrierDropdowns ],
        props : [ 'role' ],

        data() {

            return {

                loading: false,
                end_date: moment(new Date()).format('MM/DD/YYYY'),
                start_date: moment(new Date()).subtract(14, 'days').format('MM/DD/YYYY'),
                caregiver_id: '',
                items: [],
                fields: [
                    {
                        key: "caregiver",
                        label: "Independent Provider",
                        sortable: true,
                    },
                    {
                        key: "clients",
                        label: "Associated Claimants",
                        sortable: true,
                    },
                    {
                        key: "evv_method",
                        label: "EVV Method",
                        sortable: true,
                    },
                    {
                        key: "failures",
                        label: "Number of Failures",
                        sortable: true,
                    },
                    {
                        key: "caregiver_phone",
                        label: "IP Phone Number",
                        sortable: true,
                    },
                    {
                        key: "send_training_email",
                        label: "Send Training Email",
                        sortable: false,
                    },
                    {
                        key: 'training_email_sent_at',
                        label: 'Training Email Last Sent',
                        sortable: true,
                        formatter: x => x ? moment.utc(x).local().format('L LT') : '-',
                    },
                    {
                        key: 'last_failure',
                        label: 'Last Failure',
                        sortable: true,
                        formatter: x => x ? moment.utc(x).local().format('L LT') : '-',
                    }
                ],
            }
        },

        computed: {

            queryString() {

                return '?start_date=' + this.start_date + '&end_date=' + this.end_date + '&caregiver_id=' + this.caregiver_id + '&carriers=' + this.carrier_query_string;
            }
        },

        methods: {

            formatDate(date) {
                return moment.utc(date).local().format('L LT');
            },

            reload() {

                this.loading = true;
                axios.get( `/business/reports/frequent-offenders${this.queryString}` )
                    .then( ({ data }) => {

                        this.items = Array.isArray( data ) ? data : [];
                        this.loading = false;
                    });
            },

            sendTrainingEmail(caregiver) {
                if (!confirm('Are you sure you wish to send a training email to ' + caregiver.name + '?')) {
                    return;
                }

                let form = new Form();
                form.post('/business/caregivers/' + caregiver.id + '/send_training_email')
                    .then( ({ data }) => {
                        let index = this.items.findIndex(obj => {
                            return obj.caregiver.id == caregiver.id;
                        });
                        if (index >= 0) {
                            this.items[index].training_email_sent_at = data.data.training_email_sent_at;
                        }
                    });
            }
        },

        mounted() {

        }
    }
</script>